/* eslint-disable react/prop-types */
/* eslint-disable react/no-danger */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import loadable from '@loadable/component';

import ModuleTitle from 'gatsby-core-theme/src/components/atoms/module-title';
import { anchorLink } from 'gatsby-core-theme/src/helpers/strings';
import styles from 'gatsby-core-theme/src/components/molecules/module/module.module.scss';

const Modules = ({ module, pageContext, page }) => {
  const GetModuleComponent = (moduleItem) => {
    const { relation } = pageContext?.page;

    // For match cards: if there is no data, return null ModuleComponent
    const schedule = relation?.schedule;
    const scheduleArray = schedule && Object.keys(schedule).map((key) => schedule[key]);
    const tournaments = scheduleArray && scheduleArray[0]?.tournaments;
    const tournamentsArray = tournaments && Object.keys(tournaments).map((key) => tournaments[key]);
    const featuredEvents = relation?.featured_events?.slice(0, 3);
    const date = new Date();
    const today = date.getDate();
    const todayTournamentsArray =
      tournamentsArray &&
      tournamentsArray[0].events &&
      tournamentsArray[0].events?.length &&
      tournamentsArray[0].events.filter((item) => item?.date?.day_number === today);
    const scheduledEvents = todayTournamentsArray?.length && todayTournamentsArray.slice(0, 3);
    const providers = relation?.providers?.length !== 0;

    switch (moduleItem.name) {
      // Modules
      case 'top_list':
        return loadable(() => import('gatsby-core-theme/src/components/organisms/toplist'));
      case 'content':
        if (module.style === 'match_calendar_content' && Object.keys(schedule).length !== 0) {
          return loadable(() => import('../content'));
        }
        if (module.style !== 'match_calendar_content') {
          return loadable(() => import('../content'));
        }
        return null;
      case 'accordion':
        return loadable(() => import('gatsby-core-theme/src/components/organisms/accordion'));
      // Template blocks
      case 'match_cards':
        if (
          (relation?.sport?.name === 'soccer' && featuredEvents?.length) ||
          (relation?.sport?.name === 'soccer' && scheduledEvents?.length)
        ) {
          return loadable(() => import('../../../../components/organisms/template-block-cards'));
        }
        return null;
      case 'homepage_bottom':
        return loadable(() => import('../../../../components/molecules/home-bottom-content'));
      case 'match_schedule':
        if (scheduleArray?.length !== 0) {
          return loadable(() => import('../../../../components/organisms/schedule'));
        }
        return null;
      case 'match_calendar':
        if (Object.keys(schedule).length !== 0) {
          return loadable(() => import('../../../../components/organisms/match-calendar'));
        }
        return null;
      case 'match_calendar_tabs':
        return loadable(() => import('../../../../components/organisms/match-calendar-tabs'));
      case 'providers_tabs':
        if (providers) {
          return loadable(() => import('../../../../components/organisms/providers'));
        }
        return null;
      case 'sponsored_providers':
        return loadable(() => import('../../../../components/organisms/sponsored-provider'));
      case 'provider_review_banner':
        return loadable(() => import('../../../../components/molecules/provider-banner'));
      case 'about_us_buttons':
        return loadable(() => import('../../../../components/molecules/about-us-buttons'));
      case 'about_us_content':
        return loadable(() => import('../../../../components/atoms/about-us-content'));
      case 'live_stream_content':
        return loadable(() => import('../../../../components/atoms/live-stream-content'));
      case 'cookies_page_content':
        return loadable(() => import('../../../../components/organisms/cookies-page-content'));
      case 'provider_list':
        return loadable(() => import('../../../../components/organisms/provider-list'));
      case 'contact_us_content':
        return loadable(() => import('../../../../components/atoms/contact-content'));
      case 'game_page_content':
        return loadable(() => import('../../../../components/atoms/game-page-content'));
      case 'providers_banner':
        return loadable(() => import('../../../../components/atoms/providers-banner'));
      default:
        return null;
    }
  };

  const ModuleComponent = GetModuleComponent(module);

  const moduleClassName = `${module.name}Module`;

  const moduleBackgroundColor = {
    '--module-background-color': module.background_color,
  };

  return (
    ModuleComponent && (
      <div
        id={module.anchor_label && `${anchorLink(module.anchor_label)}`}
        style={module.background_color && moduleBackgroundColor}
        className={`${styles[moduleClassName] !== undefined ? styles[moduleClassName] : ''} ${
          module.name
        } ${styles.module} ${module?.style && styles[module.style]} module`}
      >
        <ModuleTitle module={module} />
        {module.module_introduction && (
          <div dangerouslySetInnerHTML={{ __html: module?.module_introduction }} />
        )}
        <ModuleComponent module={module} pageContext={pageContext} page={page} />
      </div>
    )
  );
};

Modules.propTypes = {
  module: PropTypes.shape({
    anchor_label: PropTypes.string,
    name: PropTypes.string,
    style: PropTypes.string,
    background_color: PropTypes.string,
  }),
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      relation: PropTypes.shape({}),
    }),
  }),
  page: PropTypes.shape({}),
};

export default Modules;
